var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavbarNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.277832,
    width: 32,
    height: 32,
    rx: 14,
    fill: "#A2AACA",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.001 23.2778C16.8711 23.2778 17.583 22.5855 17.583 21.7394H14.419C14.419 22.1474 14.5856 22.5387 14.8823 22.8272C15.179 23.1157 15.5814 23.2778 16.001 23.2778ZM20.747 18.6624V14.8163C20.747 12.4548 19.4498 10.4778 17.1875 9.95475V9.43168C17.1875 8.79322 16.6575 8.27783 16.001 8.27783C15.3444 8.27783 14.8145 8.79322 14.8145 9.43168V9.95475C12.5443 10.4778 11.2549 12.4471 11.2549 14.8163V18.6624L10.2345 19.6548C9.73618 20.1394 10.0842 20.9701 10.7882 20.9701H21.2058C21.9098 20.9701 22.2658 20.1394 21.7674 19.6548L20.747 18.6624Z",
    fill: "#A2AACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarNotification);
export default __webpack_public_path__ + "static/media/navbar_notification.f43ff0ff4bf49e1300a685b11748d015.svg";
export { ForwardRef as ReactComponent };